import { Column } from "@faire/web/slate/Layout";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
export var CombineOrdersIA = function CombineOrdersIA(_ref) {
  var shipInternational = _ref.shipInternational;
  if (shipInternational) {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "9Brnnd",
      defaultMessage: "To combine orders that are shipping internationally, you\u2019ll need to edit one of the orders and add all the items from the other order. Once you\u2019ve done that, you can go ahead and cancel the second order and ship these orders out as one. Please keep in mind, you cannot combine ready-to-ship orders with preorders."
    })));
  } else {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "Nmy24O",
      defaultMessage: "You can\u2019t currently combine multiple orders. Please contact us below for assistance, and we can add the same tracking information to multiple orders for you. This will ensure that your customer can access tracking details, and shipments are updated accurately."
    })));
  }
};